import React from 'react';
import { motion } from 'framer-motion';
interface BarData {
  label: string;
  value: number;
  displayValue: string;
  color?: string;
  highlight?: boolean;
}
interface AnimatedBarChartProps {
  data: BarData[];
  maxValue?: number;
  className?: string;
}
export function AnimatedBarChart({
  data,
  maxValue,
  className = ''
}: AnimatedBarChartProps) {
  const max = maxValue || Math.max(...data.map(d => d.value));
  return <div className={`w-full space-y-4 ${className}`} data-id="element-237">
      {data.map((item, i) => <div key={i} className="relative" data-id="element-238">
          <div className="flex justify-between text-sm mb-1" data-id="element-239">
            <span className="text-white/80 font-medium" data-id="element-240">{item.label}</span>
            <span className={`font-bold ${item.highlight ? 'text-[#ffd700]' : 'text-white'}`} data-id="element-241">
              {item.displayValue}
            </span>
          </div>
          <div className="h-4 bg-white/10 rounded-full overflow-hidden" data-id="element-242">
            <motion.div className={`h-full rounded-full ${item.highlight ? 'bg-[#ffd700]' : 'bg-[#4fd1c5]'}`} initial={{
          width: 0
        }} animate={{
          width: `${item.value / max * 100}%`
        }} transition={{
          duration: 1,
          delay: i * 0.1,
          ease: 'easeOut'
        }} data-id="element-243" />
          </div>
        </div>)}
    </div>;
}